import MovingLine, { movingLineProps } from './pack/MovingLine'
import Spinner, { spinnerProps } from './pack/Spinner'
import _ from 'lodash'

const LoadingMap = {
  movingLine: MovingLine,
  spinner: Spinner,
}

export default {
  name: 'KLoading',
  functional: true,
  props: {
    ...movingLineProps,
    ...spinnerProps,
    name: {
      type: String,
      default: '',
    },
    delay: {
      type: Number,
      delay: 0,
    },
  },
  render(createElement, context) {
    const name = _.camelCase(context.props.name + '')
    const data = _.assign({}, context.data, { props: context.props })

    return createElement(LoadingMap[name], data, context.slots().default)
  },
}
